import request from '@/api/request.js'

const apis = {
  readByAgent(params) {
    return request({ url: `/admin_agent_activation_quota/readByAgent`, method: 'POST', data: params })
  },
  add(params) {
    return request({ url: `/admin_agent_activation_quota/add`, method: 'POST', data: params })
  },
  remove(params) {
    return request({ url: `/admin_agent_activation_quota/remove`, method: 'POST', data: params })
  },
  change(params) {
    return request({ url: `/admin_agent_activation_quota/change`, method: 'POST', data: params })
  },
}

export default apis
